import { render, staticRenderFns } from "./BlockPopulation.vue?vue&type=template&id=3981448b&scoped=true&"
import script from "./BlockPopulation.vue?vue&type=script&lang=js&"
export * from "./BlockPopulation.vue?vue&type=script&lang=js&"
import style0 from "./BlockPopulation.vue?vue&type=style&index=0&id=3981448b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3981448b",
  null
  
)

export default component.exports